import { schema } from 'normalizr';

export const unitAction = new schema.Entity('unitActions', {}, { idAttribute: 'unitActionId' });
export const unitActions = [unitAction];

export const unitActionConfiguration = new schema.Entity(
  'unitActionConfigurations',
  {},
  { idAttribute: 'unitActionConfigurationId' }
);
export const unitActionConfigurations = [unitActionConfiguration];
